// extracted by mini-css-extract-plugin
export default {"overlay":"rh94Zs","title":"ZjYIbz","text":"Up9lbP"};